import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDailyQuestions } from '../data/quizData';
import { useAppContext } from '../context/AppContext';
import Header from "../components/Header";
import Sidebar from "../components/SideBar";
import BottomNav from "../components/BottomNav";

const InactiveUserQuiz = () => {
  const [dailyQuestions] = useState(() => getDailyQuestions());
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [userAnswers, setUserAnswers] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [showResult, setShowResult] = useState(false);

  const { resetUserContext } = useAppContext();
  const navigate = useNavigate();

  const handleOptionSelect = (option) => setSelectedOption(option);

  const currentQuestion = dailyQuestions[currentQuestionIndex];

  const handleNext = () => {
    if (!selectedOption) return;
    const newAnswers = [...userAnswers, { questionId: currentQuestion.id, answer: selectedOption }];
    setUserAnswers(newAnswers);
    setSelectedOption('');
    if (currentQuestionIndex < dailyQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setShowResult(true);
    }
  };

  const handleQuizSubmit = async () => {
    if (resetUserContext) resetUserContext();
    navigate('/enter-mobile');
  };

  const renderQuiz = () => (
    <>
      <h2 style={styles.title}>Daily Brain Challenge</h2>
      <div style={styles.quizBox}>
        <div style={styles.progress}>Question {currentQuestionIndex + 1} of {dailyQuestions.length}</div>
        <h3 style={styles.questionText}>{currentQuestion?.question}</h3>
        <div style={styles.optionsContainer}>
          {currentQuestion?.options.map((option, index) => (
            <div key={index} 
                 style={{...styles.optionBlock, backgroundColor: selectedOption === option ? '#680229' : '#fff', color: selectedOption === option ? '#fff' : '#333'}}
                 onClick={() => handleOptionSelect(option)}>
              {option}
            </div>
          ))}
        </div>
      </div>
      <button onClick={handleNext} disabled={!selectedOption} style={styles.button}>
        {currentQuestionIndex === dailyQuestions.length - 1 ? '✨ Show Results' : '👉 Next Question'}
      </button>
    </>
  );

  const renderResult = () => {
    let score = 0;
    userAnswers.forEach(ans => {
      const q = dailyQuestions.find(qItem => qItem.id === ans.questionId);
      if (q && q.correctAnswer === ans.answer) score++;
    });
    return (
      <div>
        <h2 style={styles.title}>Today's Results</h2>
        <p>Your Score: {score} out of {dailyQuestions.length}</p>
        <button onClick={handleQuizSubmit} style={styles.button}>Thanks for Playing!</button>
      </div>
    );
  };

  return (
    <div className="mainhome-screen-wrapper">
      <Header onMenuClick={() => setSidebarOpen(true)} isAccountActive={false} />
      {isSidebarOpen && <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />}
      <div style={{ padding: '20px', display: 'flex', justifyContent: 'center' }}>
        <div style={styles.card}>{showResult ? renderResult() : renderQuiz()}</div>
      </div>
      <BottomNav active="Home" />
    </div>
  );
};

const styles = {
  card: { backgroundColor: '#f5f5f5', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '500px', textAlign: 'center' },
  title: { color: '#000', fontWeight: '700', fontSize: '22px' },
  questionText: { fontSize: '18px', marginBottom: '20px' },
  optionBlock: { padding: '14px', borderRadius: '12px', border: '2px solid #e0e0e0', cursor: 'pointer', marginBottom: '10px' },
  button: { width: '100%', padding: '16px', background: 'linear-gradient(135deg, #680229, #a30d3a)', color: '#fff', border: 'none', borderRadius: '30px', cursor: 'pointer' }
};

export default InactiveUserQuiz;
